<template>
    <div>
        <div class="input-group mm-inputdate">
            <div class="input-group-prepend">
                <button class="btn btn-outline-secondary" @click.prevent="clickButton"><i class="mm-icon mm-icon-calendar"></i></button>
            </div>
            <masked-input
                type="text"
                :name="nameMaskInput"
                :class="['form-control', { masked:  activeMask}]"
                v-model="inputMask"
                v-on:change="emitEvent('change')"
                v-on:keyup="emitEvent('keyup')"
                :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                :guide="true"
                :showMask="true"
                placeholderChar="_">
            </masked-input>
        </div>
        <Teleport to="body">
            <mmDatepicker @input="recogerFecha" ref="modaldatepicker"></mmDatepicker>
        </Teleport>
    </div>
</template>

<script>
    import MaskedInput from 'vue-text-mask'
    import Teleport from 'vue2-teleport';
    import mmDatepicker from './mmDatepicker.vue'
    export default {
        name: 'mmInputDate',
        components: {
            Teleport,
            MaskedInput,
            mmDatepicker
        },
        props: ['value', 'name'],
        data() {
            return {
                inputMask: '',
                nameMaskInput: ''
            }
        },
        created: function() {
            this.nameMaskInput = this.name;
            if (this.value != '' && this.value != '01/01/1753') this.inputMask = this.value
        },
        methods: {
            emitEvent(event) {
                this.$emit(event, this.inputMask);
            },
            clickButton() {
                this.$refs.modaldatepicker.openModal(this.inputMask);
            },
            recogerFecha(fecha) {
                let _emitEvent = fecha!=this.inputMask;
                let self = this;
                this.inputMask = fecha;
                
                if(_emitEvent) {
                    //se pone un retraso, porque sino se ejecute el change, pero el watch de inputMask aun no ha terminado
                    setTimeout(()=>{
                        self.emitEvent('change');
                    },100);
                }
                
            }
        },
        computed: {
            activeMask: function () {
                return !(/\d/.test(this.inputMask));
            }
        },
        watch: {
            inputMask: function(v) {
                //sino hay numero, significa que solo tiene la mask, entonces devolvemos vacio
                this.$emit('input', /\d/.test(v) ? v : '');
            },
            value: function(v) {
                this.inputMask = v;
            }
        }
    }
</script>

<style>
.mm-inputdate input.masked {
    color: #ccc;
}
</style>